var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoader),expression:"showLoader"}],staticClass:"page-Loader",style:({width: _vm.width})})}
var staticRenderFns = []

export { render, staticRenderFns }